// Utility to determine if FloatingFavoritesButton should be mounted in the page tree.
// Intentionally does NOT check numberOfFavorites — the component manages its own
// visibility internally so that server and client always agree on whether it is
// present as a React child (preventing hydration mismatches caused by the
// favorites count being 0 on SSR but >0 on the client).
// Used in Page.tsx and MainContent to decide whether to mount the component.
export function shouldRenderFloatingFavoritesButton({ asPath, isFlyingFlowers, subject, }) {
    var _a;
    return (!isFlyingFlowers &&
        (asPath === '/' ||
            asPath.startsWith('/category/') ||
            !!((_a = subject === null || subject === void 0 ? void 0 : subject.category) === null || _a === void 0 ? void 0 : _a.name) ||
            asPath.startsWith('/search') ||
            asPath.startsWith('/product/')));
}
